import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { State } from "../../redux";
import WizardContainer from "../../components/container/WizardContainer";

const hasRequiredUserData = (currentUser: State["user"]["currentUser"]) =>
	!!(currentUser?.name && currentUser?.surname && currentUser?.email);

const FelicitacionAuth = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const currentUser = useSelector((state: State) => state.user.currentUser);

	useEffect(() => {
		if (hasRequiredUserData(currentUser)) {
			navigate("/felicitacion", {
				replace: true,
				state: {
					autostart:
						(location.state as { autostart?: boolean } | undefined)
							?.autostart ?? false,
				},
			});
		}
	}, [currentUser, location.state, navigate]);

	return (
		<WizardContainer
			views={[
				{
					hideNavBar: true,
					centralView: null,
				},
			]}
		/>
	);
};

export default FelicitacionAuth;
